import { NativeSelect } from "@mui/material";
import { styled } from "@mui/system";

const StyledNativeSelect = styled(NativeSelect)(({ theme }) => {
  return {
    transition: "all 0.3s",
    "&.MuiInputBase-root": {
      transition: "none",
      border: "none",
      borderBottom: `1px solid ${theme.palette.secondary.main}`,
      "& .MuiNativeSelect-icon": {
        display: "block",
        marginTop: "2px",
      },
    },
    "&.MuiInputBase-root.MuiNativeSelect-root::before": {
      border: "none",
    },
    "& .MuiInputBase-input": {
      outline: "none",
      position: "relative",
      backgroundColor: theme.palette.background.main,
      border: "none",
      fontSize: 14,
      "&:focus": {
        border: "none",
      },
      fontWeight: 500,
      color: theme.palette.secondary.main,
    },

    "& .MuiOutlinedInput-notchedOutline": {
      outline: "none",
    },
  };
});

export default StyledNativeSelect;
